import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateTenderModel, Tender, EditTenderModel } from "../../models/inModels/Tender";

@Injectable()
export class TenderService {
	private routeCategory = '/api/tenders';
	private routeProvince = '/api/province';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<Tender> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Tender)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateTenderModel): Promise<Tender> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Tender)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditTenderModel): Promise<Tender> {
		return this.http.post(`${this.auth.apiUrl}/api/tenders/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Tender)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownList(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeProvince}/dropdown`, { headers: this.auth.header })
		.toPromise()
		.then(response => response)
		.catch(error => this.logging.handleError(error));
	}
	getProvinceDropdown(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeProvince}/dropdown`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	getTenderTypeDropdownList(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/dropdown`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/business/tender.service.ts